import React from "react";
import { Caste, Designation, District, EmployeeSalary, FiscalYear, GeneralLedger, ItemCategory, MenuProps, Municipality, OptPaymentMode, OptProductIssueList, OptProductList, OptProductMemList, OptProductSalesList, OptProductStore, OptProductSupplier, OptProductUnit, OptSubGLLedger, Particular, ProductMaster, Province, Reader, SearchMemberList, SubLedger, SubMenuProps, TapSize, Tole } from "../helpers/models/Models";

export const ReservationStatusOptions = [
    { value: "1", label: "Conformed" },
    { value: "2", label: "Provisional" },
    { value: "3", label: "Wait-Listed" },
];

export const BranchOptions = [
    { value: "1", label: "Main Branch" },
    { value: "2", label: "Branch 1" },
];

export const YesNoOptions = [
    { value: "1", label: "Yes" },
    { value: "2", label: "No" },

];
export const NepaliMonthOptions = [
    { value: "1", label: "Baishakh" },
    { value: "2", label: "Jesth" },
    { value: "3", label: "Ashadh" },
    { value: "4", label: "Shrawan" },
    { value: "5", label: "Bhadra" },
    { value: "6", label: "Ashwin" },
    { value: "7", label: "Kartik" },
    { value: "8", label: "Mangsir" },
    { value: "9", label: "Poush" },
    { value: "10", label: "Magh" },
    { value: "11", label: "Falgun" },
    { value: "12", label: "Chaitra" },
];


export const MenuOptions = (items: MenuProps[]) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.menu_id.toString(),
            label: item.name
        }));
    } else {
        return [];
    }
};

export const SubMenuOptions = (items: SubMenuProps[]) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sub_m_id.toString(),
            label: item.name
        }));
    } else {
        return [];
    }
};


export const FiscalYearOptions = (items: FiscalYear[]) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.fiscal_year_id.toString(),
            label: item?.fiscal_year_name?.toString(),
            from_date_n: item.from_date_n,
            to_date_n: item.to_date_n,
        }));
    } else {
        return [];
    }
};

export const MeterTypeOptions = [
    { value: "1", label: "Personal" },
    { value: "2", label: "Organization" },
];

export const MeterStatusOptions = [
    { value: "1", label: "Connection is Active" },
    { value: "2", label: "Connection is Process" },
];
export const TapTypeOptions = [
    { value: "1", label: "Permanent" },
    { value: "2", label: "Temporary" },
];

export const MemberTypeOptions = [
    { value: "1", label: "Apang" },
    { value: "2", label: "Normal" },
];
export const VoucherTypeOptions = [
    { value: "1", label: "Single Voucher" },
    { value: "2", label: "Contra Voucher" },
];
export const TapStatusOptions = [
    { value: "1", label: "Bigreko" },
    { value: "2", label: "Khapat Nabhayako" },
    { value: "3", label: "Sewa Banda" },
];

export const GenderOptions = [
    { value: "1", label: "Male" },
    { value: "2", label: "Female" },
    { value: "3", label: "Others" },
];
export const LedgerTypeOptions = [
    { value: "1", label: "Assets" },
    { value: "2", label: "Liabilities" },
    { value: "3", label: "Income" },
    { value: "4", label: "Expenses" },
];
export const DebitCreditOptions = [
    { value: "1", label: "Debit" },
    { value: "2", label: "Credit" },
];
export const ToleOptions = (items: Tole[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sn.toString(),
            label: item.tole_name,
        }));
    } else {
        return [];
    }
};
export const ProvinceOptions = (items: Province[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.province_id.toString(),
            label: item.province_name,
        }));
    } else {
        return [];
    }
};

export const TapSizeOptions = (items: TapSize[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sn.toString(),
            label: item.tap_size,
        }));
    } else {
        return [];
    }
};

export const GeneralLedgerOptions = (items: GeneralLedger[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.glid.toString(),
            label: `${item.glid}. ${item.gl_name}`,
        }));
    } else {
        return [];
    }
};
export const SubLedgerOptions = (items: SubLedger[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sglsn?.toString(),
            label: `${item.sglsn}. ${item.sub_ledg_name}`,
            mem_cate_id: item.mem_cate_id
        }));
    } else {
        return [];
    }
};

export const ParticularOptions = (items: Particular[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.particular_id.toString(),
            label: `${item.particular_id}. ${item.particular_name}`,
            is_debit: item.is_debit,
        }));
    } else {
        return [];
    }
};

export const SearchMemberListOptions = (items: SearchMemberList[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.member_sn.toString(),
            label: `${item.member_sn}. ${item.mem_name} | Phone No.: ${item.phone_no || ""} | Address: ${item.add_eng || ""}`,
            mem_name: item?.mem_name,
            marga_tole: item?.tole_name
        }));
    } else {
        return [];
    }
};

export const SearchMemberListMahasulOptions = (items: SearchMemberList[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.member_sn.toString(),
            label: `${item.member_sn}. ${item.mem_name} | Phone No.: ${item.phone_no || ""} | Address: ${item.add_eng || ""}`,
            prev_unit: item.consumers?.unit_total,
            marga_name: item.tole_name,
            tap_size_name: item.tap_size_name,
            reader: item?.reader,
            tap_size_id:item.tap_size

        }));
    } else {
        return [];
    }
};
export const CasteOptions = (items: Caste[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.caste_id.toString(),
            label: item.caste_name,
        }));
    } else {
        return [];
    }
};
export const DistrictOptions = (items: District[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.district_id.toString(),
            label: item.district_name,
        }));
    } else {
        return [];
    }
};
export const ReaderOptions = (items: Reader[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sn.toString(),
            label: item.reader_name,
        }));
    } else {
        return [];
    }
};

export const MunicipalityOptions = (items: Municipality[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.muni_id.toString(),
            label: item.muni_name,
        }));
    } else {
        return [];
    }
};

export const generateRangeOptions = (number: number | null, step: number | null): number[] => {
    if (number === null || step === null || step <= 0) {
        return []; // Return an empty array if inputs are invalid
    }

    // Determine the nearest lower multiple of step
    const start = Math.floor(number / step) * step;

    // Determine the nearest upper multiple of step
    const end = start + step * 3; // Extend the range as needed

    // Generate options
    const options: number[] = [];
    for (let i = start; i <= end; i += step) {
        options.push(i);
    }

    return options;
};

interface Range {
    muni_id: number;
    muni_name: number;
}

export const RangeOptions = (items: Range[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.muni_id.toString(),
            label: item.muni_name,
        }));
    } else {
        return [];
    }
};


export const UserOptions = [
    { value: "1", label: "1. Sushil KC | 9864563927 | Badachaur Rolpa" },
    { value: "2", label: "2. Ramita KC | 9864563927 | Badachaur Rolpa" },
    { value: "3", label: "2. Ramita KC | 9864563927 | Badachaur Rolpa" },
    { value: "4", label: "2. Ramita KC | 9864563927 | Badachaur Rolpa" },
    { value: "5", label: "2. Ramita KC | 9864563927 | Badachaur Rolpa" },
    { value: "6", label: "2. Ramita KC | 9864563927 | Badachaur Rolpa" },
    { value: "7", label: "2. Ramita KC | 9864563927 | Badachaur Rolpa" },


];

export const MasterCategoryOptions = (items: ProductMaster[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sn.toString(),
            label: `${item.sn}. ${item.name}`,
        }));
    } else {
        return [];
    }
};
export const SubCategoryOptions = (items: ItemCategory[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sn.toString(),
            label: `${item.sn}. ${item.name}`,
        }));
    } else {
        return [];
    }
};
export const ProductSuppilerOptions = (items: OptProductSupplier[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sn.toString(),
            label: `${item.sn}. ${item.supp_name}`,
        }));
    } else {
        return [];
    }
};
export const UnitOptions = (items: OptProductUnit[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sn.toString(),
            label: `${item.sn}. ${item.short_name}`,
        }));
    } else {
        return [];
    }
};

export const ProductPurchaseOptions = (items: OptProductList[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sn.toString(),
            label: `${item.sn}. ${item.pro_name} | Purchase Rate: ${item.pur_rate || 0} ${item?.purchase_unit_name} | Sizes: ${item.sizes || "-"}`,
            pur_rate: item.pur_rate,
            vat_perc: item?.vat_perc,
            disc_amt: item?.disc_amt,
            disc_perc: item?.disc_perc,
        }));
    } else {
        return [];
    }
};

export const ProductStoreOptions = (items: OptProductStore[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sn.toString(),
            label: `${item.sn}. ${item.store_name}`,
        }));
    } else {
        return [];
    }
};

export const PurchaseStatusOptions = [
    { value: "1", label: "Ordered" },
    { value: "3", label: "Pending" },
    { value: "2", label: "Received" },

];
export const PaymentModeOptions = (items: OptPaymentMode[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sn.toString(),
            label: `${item.sn}. ${item.sub_ledger_type_name}`,
        }));
    } else {
        return [];
    }
};

export const ProductSubLedgerOptions = (items: OptSubGLLedger[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sglsn.toString(),
            label: `${item.sglsn}. ${item.sub_ledg_name}`,
        }));
    } else {
        return [];
    }
};


export const ProductListIssueOptions = (items: OptProductIssueList[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.product_id.toString(),
            label: `${item.product_id}. ${item.pro_name} | Total Available: ${item.total_purchase} | Sales Rate: ${item.sales_rate}`,
            total_issuable: item.total_purchase,
            store_id: item.store_id,
        }));
    } else {
        return [];
    }
};


export const ProductMemberIssueOptions = (items: OptProductMemList[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.member_sn.toString(),
            label: `${item.member_sn}. ${item.mem_name} | Phone No: ${item.phone_no || 0} | Address: ${item.add_eng || "-"}`,
        }));
    } else {
        return [];
    }
};

export const ProductSalesOptions = (items: OptProductSalesList[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.product_id?.toString(),
            label: `${item.product_id}. ${item.pro_name} | Total Available: ${item?.total_purchase || 0} | Sales Rate: ${item?.pur_rate || 0} | Sizes: ${item?.sizes || "-"}`,
            sale_rate: item.sales_rate,
            vat_perc: item?.vat_perc,
            disc_amt: item?.disc_amt,
            disc_perc: item?.disc_perc,
            total_purchase: item?.total_purchase,
        }));
    } else {
        return [];
    }
};


export const DesignationOptions = (items: Designation[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.sn.toString(),
            label: `${item.sn}. ${item.name}`,
        }));
    } else {
        return [];
    }
};

export const EmployeeOptions = (items: EmployeeSalary[] | undefined) => {
    if (items && Array.isArray(items)) {
        return items.map((item) => ({
            value: item.member_sn.toString(),
            label: `${item.member_sn}. ${item.mem_name} | Phone No.: ${item.sms_mob_no || ""}`,
            designation: item.designation,
            basic_sal: item.initial_salary||"",
            grade_count: item.grade_count|| "",
            grade_amount: item.grade_amt || "",
            basic_tot_amount: (item.initial_salary)+(item.grade_count * item.grade_amt) ||"",
            pf: item.pf_amount || "",
            pf_thap: item.pf_thap_amt  || "",
            pf_total: item.pf_amount+item.pf_thap_amt ||"",
            thap: item.pf_amount + item.pf_thap_amt || "",
            abs_day: "",
            att_day: "",
            abs_amt: "",
            other_al: "",
            total_salary: item.pf_amount + item.pf_thap_amt || "",
            tax: item.tax_amount||"",
            sa_su_tax: item.ss_tax ||"",
            other_less_amt:  "0",
            abs_day_less: "",
            abs_amt_less: "",
            net_salary: (item.initial_salary)+(item.grade_count * item.grade_amt) +(item.pf_amount+item.pf_thap_amt)-(item.tax_amount+item.ss_tax) ||"",
            posted_tsn: "",
            remarks: "",
            upadan_thap: "",
            upadan_katti: "",
            post: "",
        }));
    } else {
        return [];
    }
};

export const memterStatusOptions = [
    { value: '1', label: 'Meter Bigreko' },
    { value: '2', label: 'Pani Khapat nabhayako' },
    { value: '3', label: 'Sewa Banda Bhayako' },
];

export const StockReportOptions = [
    { value: "1", label: "Total Seles" },
    { value: "2", label: "Total Purchase" },
    { value: "3", label: "Total Issue" },
    { value: "4", label: "Total Available" },

];